/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/127-spinner5': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zm0 4a4 4 0 110 8 4 4 0 010-8zm4.773 8.773C11.498 14.048 9.803 14.75 8 14.75s-3.498-.702-4.773-1.977S1.25 9.803 1.25 8c0-1.803.702-3.498 1.977-4.773l1.061 1.061a5.256 5.256 0 000 7.425c.992.992 2.31 1.538 3.712 1.538s2.721-.546 3.712-1.538a5.256 5.256 0 000-7.425l1.061-1.061C14.048 4.502 14.75 6.197 14.75 8s-.702 3.498-1.977 4.773z"/>'
  }
})
